// src/appShell.js
//
// Uygulama kabuğu kararları. App.js'ten ayrı bir modülde durur; böylece
// (App.js'in tüm rota ağacını yüklemeden) birim testle doğrulanabilir.

/**
 * Yönetim kabuğunun (sol kenar menüsü) açık kalacağı rotalar.
 *
 * Yönetim ekranları iki ön ek altında toplanır: "/editor/…" ve "/yonetim/…".
 * Daha önce burada yalnızca "/yonetim/admin" ön ekine bakılıyordu; bu yüzden
 * Haftanın Enleri (/yonetim/haftanin-enleri), Piyasa Değeri Yönetimi gibi
 * sayfalara girildiğinde yan menü kayboluyor ve kullanıcı tarayıcının geri
 * düğmesi dışında hiçbir yere gidemiyordu.
 *
 * Kabuğun dışında tutulan istisnalar:
 *   "/yonetim/takimim" — eski takım başkanı paneli; artık /panel'e
 *                        yönlendirilir, kabuk kararı da yönlendirme öncesi
 *                        titremesin diye dışarıda tutulur.
 *   "/yonetim/giris"   — yönetim giriş sayfası; oturum daha açılmadığı için
 *                        yan menü gösterilmemelidir.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export function isManagementShellPath(pathname) {
  const path = String(pathname || "");
  if (path === "/editor" || path.startsWith("/editor/")) return true;
  if (path === "/admin/weekly-awards") return true;
  if (path === "/yonetim/takimim" || path.startsWith("/yonetim/takimim/")) return false;
  if (path === "/yonetim/giris") return false;
  return path === "/yonetim" || path.startsWith("/yonetim/");
}

/**
 * Yayın kaplaması (OBS tarayıcı kaynağı) rotaları.
 *
 * Bu ekranlarda sitenin kabuğu — üst menü, footer — GÖRÜNMEMELİDİR: kaplamanın
 * her pikseli yayına düşer, sayfanın altında beliren site footer'ı doğrudan
 * ekrana gider.
 *
 * Liste tek yerde durur, çünkü daha önce her yeni kaplama eklendiğinde
 * App.js'teki uzun koşula bir satır daha yazmak gerekiyordu ve kura kaplaması
 * eklenirken bu satır unutuldu: /kura-overlay sayfasının altında sitenin
 * footer'ı yayına çıktı.
 */
const OVERLAY_PATH_PREFIXES = [
  "/skoroverlay",
  "/skorboard/canli",
  "/led",
  "/altyazi",
  "/kura-overlay",
  "/panorama",
];

/**
 * @param {string} pathname
 * @returns {boolean} yol bir yayın kaplaması mı?
 */
export function isOverlayPath(pathname) {
  const path = String(pathname || "");
  return OVERLAY_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}
